import { render, staticRenderFns } from "./PhoneRegistration.vue?vue&type=template&id=2a9ccc07&scoped=true&"
import script from "./PhoneRegistration.vue?vue&type=script&lang=js&"
export * from "./PhoneRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PhoneRegistration.vue?vue&type=style&index=0&id=2a9ccc07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9ccc07",
  null
  
)

export default component.exports